import React, {Component} from 'react';
import SubCategoryItem from './subCategoryItem';

import _ from 'lodash';

class SubCategoryPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount(){
    if(this.state.loading){
      this.setState({
        loading: false
      });
    }
  }

  render(){
    if(this.state.loading){
      return <div>Loading...</div>;
    }

    let subcategoryData = null;
    if (!_.isEmpty(this.props.subcategoryData)) {
      subcategoryData = _.map(this.props.subcategoryData, (singlecategory, index) => {
          return (
            <SubCategoryItem
              key={index}
              dynamicClass="col-md-3 col-sm-4 col-xs-6"
              info={singlecategory}
              catename={this.props.catename} />)
          }
      );
    }

    return(
      <div className="SingleCategoryPanel">
        <div className="SingleCatagoryContainer">
          {subcategoryData}
        </div>
      </div>
    );
  }
}

export default SubCategoryPanel;



// WEBPACK FOOTER //
// ./src/components/subcategories/subCategoryPanel.js